module.exports = __webpack_public_path__ + "img/about.044d797c.png";